<template>
    <div class="appLoader" v-if="appLoading">
        <v-progress-circular
            :size="60"
            :width="5"
            color="#999"
            indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "AppLoader",
        computed: {
            ...mapGetters(["appLoading"]),
        }
    };
</script>
  
<style scoped>
    .appLoader {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483642;
    }
</style>